import React, { useEffect, useState } from 'react';
export function StickyAlertBar() {
  const [seconds, setSeconds] = useState(599); // 9:59
  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(prev => {
        if (prev <= 0) return 0;
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;
  const display = `${minutes}:${secs.toString().padStart(2, '0')}`;
  return <div className="fixed top-0 left-0 right-0 z-50 bg-chocolate-900 text-gold-400 py-3 px-4 text-center shadow-md" data-id="element-244">
      <p className="text-sm md:text-base font-bold tracking-wide" data-id="element-245">
        ⏳ LA OFERTA EXPIRA EN{' '}
        <span className="inline-block min-w-[4ch] tabular-nums" data-id="element-246">{display}</span>
      </p>
    </div>;
}